export default __webpack_public_path__ + "static/media/logo.15901ad1.webp";